import {
    Component,
    inject,
    Inject,
    input,
    model,
    OnInit,
    ChangeDetectionStrategy,
} from '@angular/core';
import { Apollo, gql, QueryRef } from 'apollo-angular';
import { FormGroup, FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import {
    ProductDeliverableCreateDocument,
    ProductDeliverableCreateMutation,
    ProductDeliverablesSearchDocument,
    ProductDeliverablesSearchQuery,
} from 'src/__generated__/graphql';

const COLUMNS_SCHEMA = [
    {
        key: 'deliverableType',
        type: 'list',
        list: [
            { enum: 'CREDITS', id: 1 },
            { enum: 'SMS', id: 2 },
            { enum: 'DATA', id: 3 },
            { enum: 'MINUTES', id: 4 },
            { enum: 'OTHER', id: 100 },
        ],
        label: 'Type',
    },
    {
        key: 'unitType',
        type: 'list',
        list: [
            { id: '1', enum: 'CURRENCY' },
            { enum: 'DATA', id: 2 },
            { enum: 'MINUTES', id: 3 },
            { enum: 'QUANTITY', id: 4 },
            { enum: 'OTHER', id: 100 },
        ],
        label: 'Unit Type',
    },
    {
        key: 'unit',
        type: 'text',
        label: 'Unit',
    },
    {
        key: 'amount',
        type: 'number',
        label: 'Amount',
    },
    {
        key: 'summaryKey',
        type: 'text',
        label: 'Summary Key',
    },
    {
        key: 'isEdit',
        type: 'isEdit',
        label: '',
    },
];
@Component({
    selector: 'app-productdeliverables',
    templateUrl: './product-deliverables.component.html',
    styleUrls: ['./product-deliverables.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ReactiveFormsModule,
        MatTableModule,
        MatButtonModule,
        MatIconModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
    ],
})
export class ProductDeliverablesComponent {
    productDeliverables = new MatTableDataSource<any>();
    productDeliverablesQuery?: QueryRef<ProductDeliverablesSearchQuery>;
    productDeliverablesSubscription?: Subscription;
    displayedColumns: string[] = COLUMNS_SCHEMA.map((col) => col.key);
    productId = model.required<string>();
    columnsSchema: any = COLUMNS_SCHEMA;
    public mappingGroup!: FormGroup;
    dialogData = inject(MAT_DIALOG_DATA);

    constructor(
        private apollo: Apollo,
        private fb: FormBuilder,
    ) {
        if (this.dialogData.productId)
            this.productId.set(this.dialogData.productId);
        this.mappingGroup = this.fb.group({
            productId: [null],
            deliverableType: [null],
            unitType: [null],
            unit: [null],
            amount: [null],
            summaryKey: [null],
        });
    }
    ngAfterViewInit(): void {
        this.productDeliverablesQuery =
            this.apollo.watchQuery<ProductDeliverablesSearchQuery>({
                query: ProductDeliverablesSearchDocument,
                fetchPolicy: 'network-only',
                variables: {
                    where: { productIds: { in: this.productId() } },
                },
            });
        this.productDeliverablesSubscription =
            this.productDeliverablesQuery.valueChanges.subscribe((result) => {
                this.productDeliverables.data =
                    result?.data?.marketplaceProductSearch?.items?.[0]
                        ?.deliverables ?? [];
                this.productDeliverables.data =
                    this.productDeliverables.data.map((obj) => ({
                        ...obj,
                        isEdit: false,
                        isAdd: false,
                    }));
            });
    }
    ngOnDestroy() {
        this.productDeliverablesSubscription?.unsubscribe();
    }
    editDeliverable(element: any) {
        element.isEdit = !element.isEdit;
    }
    addDeliverable(element: any) {
        element.isEdit = !element.isEdit;
        element.isAdd = false;
        this.apollo
            .mutate<ProductDeliverableCreateMutation>({
                mutation: ProductDeliverableCreateDocument,
                variables: {
                    input: {
                        productId: this.productId(),
                        deliverableType:
                            this.mappingGroup.get('deliverableType')?.value,
                        unitType: this.mappingGroup.get('unitType')?.value,
                        unit: element.unit,
                        amount: Number(this.mappingGroup.get('amount')?.value),
                        summaryKey: this.mappingGroup.get('summaryKey')?.value,
                    },
                },
            })
            .subscribe();
    }
    addDeliverableRow() {
        const timestampMillis = Date.now();
        const newRow = {
            id: timestampMillis,
            deliverableType: '',
            unitType: '',
            amount: '',
            unit: '',
            isEdit: true,
            isAdd: true,
        };
        this.productDeliverables.data = [
            ...this.productDeliverables.data,
            newRow,
        ];
    }
    cancelAddedDeliverableRow(element: any) {
        if (element.isAdd) {
            this.productDeliverables.data =
                this.productDeliverables.data.filter((x) => x.id != element.id);
        } else {
            element.isEdit = !element.isEdit;
        }
    }
}
